import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import useActions from './useActions';
import { fetchQuestion } from 'actions';

const useQuestion = id => {
  const dispatchFetchQuestion = useActions(fetchQuestion);

  const question = useSelector(
    ({ question }) => ({ question:question.question, state: question.state }),
  );

  const memoizedFetch = useCallback(() => {
    if (id)
      dispatchFetchQuestion(id, {onSuccess: () => console.log("yooo")})
  }, [dispatchFetchQuestion, id]);

  useEffect(() => {
    memoizedFetch();
  }, [memoizedFetch]);

  return question;
};

export default useQuestion;
